import { render, staticRenderFns } from "./AccountCreateEdit.vue?vue&type=template&id=1229b80b&"
import script from "./AccountCreateEdit.vue?vue&type=script&lang=js&"
export * from "./AccountCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports